import React from 'react';
import { Link } from 'react-router-dom';

interface ATWAvatarProps {
  size?: number;
  className?: string;
  color?: string;
  asLink?: boolean;
}

export const ATWAvatar: React.FC<ATWAvatarProps> = ({ 
  size = 24, 
  className = "", 
  color = "currentColor",
  asLink = true
}) => {
  const svg = (
    <svg
      width={size}
      height={size}
      viewBox="0 0 948.3 948.3"
      className={className}
      style={{ color }}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g transform="scale(1.25) translate(-95,-95)">
        <path 
          fill="currentColor" 
          d="M558.5,425.4c-8.8,0-16.8,3.5-22.7,9.2c-0.5,0.5-1,1-1.5,1.6c-5.3,5.8-8.5,13.5-8.5,22
            c0,18.1,14.6,32.7,32.7,32.7c18.1,0,32.7-14.6,32.7-32.7C591.2,440.1,576.5,425.4,558.5,425.4z"
        />
        <path 
          fill="currentColor" 
          d="M476.6,181.9c-8.8,0-16.8,3.5-22.7,9.2c-0.5,0.5-1,1-1.5,1.6c-5.3,5.8-8.5,13.5-8.5,22
            c0,18.1,14.6,32.7,32.7,32.7c18.1,0,32.7-14.6,32.7-32.7C509.3,196.6,494.7,181.9,476.6,181.9z"
        />
        <circle fill="currentColor" cx="389.5" cy="458.1" r="32.7"/>
        <g>
          <path 
            fill="currentColor" 
            d="M557.5,628.5H390.8c-93.9,0-170.3-76.4-170.3-170.3c0-93.9,76.4-170.3,170.3-170.3h166.7
              c93.9,0,170.3,76.4,170.3,170.3C727.8,552.1,651.4,628.5,557.5,628.5z M390.8,361c-53.6,0-97.1,43.6-97.1,97.1
              c0,53.6,43.6,97.1,97.1,97.1h166.7c53.6,0,97.1-43.6,97.1-97.1c0-53.6-43.6-97.1-97.1-97.1H390.8z"
          />
        </g>
        <path 
          fill="currentColor" 
          d="M575.4,651.4c-36,12.9-67.2,24.1-98.3,35.3c-1.8,0.6-3.8,0.6-5.6,0c-31.7-11.3-62.8-22.4-98.5-35.2
            c-4.5-1.6-9.6,1-9.6,5v104.4c0,4,5.1,6.6,9.6,5c35.9-12.8,67.2-23.9,98.7-35c1.8-0.6,3.8-0.6,5.5,0c31.8,11.3,62.9,22.4,98.2,35
            c4.5,1.6,9.6-1,9.6-5V656.4C585,652.4,579.9,649.8,575.4,651.4z"
        />
        <rect x="463.4" y="227.7" fill="currentColor" width="26.4" height="67.2"/>
      </g>
    </svg>
  );

  if (asLink) {
    return (
      <Link to="/app/home" className="inline-block">
        {svg}
      </Link>
    );
  }

  return svg;
};